"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondaryFont = exports.primaryFont = void 0;
var fonts = {
    primary: "'hind', \"Arial Black\", Gadget, sans-serif",
    secondary: "'rubik', Arial, Helvetica, sans-serif"
};
var fontSize = [
    "6px",
    "8px",
    "12px",
    "14px",
    "18px"
];
exports.primaryFont = {
    xsmall: fontSize[0] + " " + fonts.primary,
    small: fontSize[1] + " " + fonts.primary,
    medium: fontSize[2] + " " + fonts.primary,
    large: fontSize[3] + " " + fonts.primary,
    xlarge: fontSize[4] + " " + fonts.primary,
};
exports.secondaryFont = {
    xsmall: fontSize[0] + " " + fonts.secondary,
    small: fontSize[1] + " " + fonts.secondary,
    medium: fontSize[2] + " " + fonts.secondary,
    large: fontSize[3] + " " + fonts.secondary,
    xlarge: fontSize[4] + " " + fonts.secondary,
};
//# sourceMappingURL=fonts.js.map